// MIME types accepted by the file-upload webhook. Used for the file input's
// `accept` attribute; the server validates by MIME and is the source of truth.
export const ALLOWED_MIMES = [
  "text/plain",
  "text/csv",
  "application/pdf",
  "application/json",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "image/jpeg",
  "image/png",
  "image/webp",
] as const;

// Extension equivalents of ALLOWED_MIMES. ValidateFiles checks by extension, so
// this is the front-end pre-filter that mirrors the server's MIME allow-list.
export const ALLOWED_EXTENSIONS = [
  "txt",
  "csv",
  "pdf",
  "json",
  "docx",
  "xlsx",
  "jpg",
  "jpeg",
  "png",
  "webp",
] as const;

export const EXTENSION_TO_MIME: Record<string, string> = {
  txt: "text/plain",
  csv: "text/csv",
  pdf: "application/pdf",
  json: "application/json",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  webp: "image/webp",
};

export const MAX_FILES = 10;

// ValidateFiles measures size in decimal MB (bytes / 1000 / 1000).
export const MAX_FILE_SIZE_MB = 10;
